export default __webpack_public_path__ + "static/media/iguana.7b0e3fc0.webp";